import React, { useEffect } from "react";
import InvalidFeedback from "../invalid-feedback/invalid-feedback.component";

export default React.forwardRef(
  (
    {
      type = "text",
      optional = false,
      label,
      errors,
      currentLength,
      maxLength,
      children,
      sizeClass = "form-control-lg",
      disabled = false,
      onFileError,
      ...register
    }: any,
    ref: any
  ) => {
    const handleChange = (e: any) => {
      if (type === "file" && e.target.files.length > 0) {
        const file = e.target.files[0];
        const ext = file.name.split(".").pop();
        if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "png") {
          alert("Solo se permiten archivos PDF, JPG, JPEG y PNG");
          onFileError();

        //   register.onChange({ target: { value: '' } });
        } else {
          register.onChange(e);
        }
      }
    };

    return (
      <>
        {label && (
          <label className="form-label">
            {label}{" "}
            {optional && (
              <span className="form-label-secondary">(Opcional)</span>
            )}
          </label>
        )}
        <div className={"d-flex " + (errors ? "is-invalid" : "")}>
          <input
            type={type}
            accept="image/*,application/pdf"
            ref={ref}
            className={
              "form-control " + sizeClass + (errors ? " is-invalid " : "")
            }
            // {...register }
            name={register.name}
            onChange={type !== "file" ? register.onChange : handleChange}
            onBlur={type !== "file" ? register.onBlur : undefined}
            disabled={disabled}
          />
          {children}
        </div>

        <InvalidFeedback error={errors} />

        {maxLength && maxLength > 0 && (
          <div className="form-text mt-1 text-end">
            {currentLength}/{maxLength}
          </div>
        )}
      </>
    );
  }
);
